import React, { Component } from 'react';
import { browserHistory } from 'react-router';
// import moment from 'moment';
import moment from 'moment-timezone';
import Select2 from 'react-select2-wrapper';
import _ from 'lodash';
import Header from '../../components/Header';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withUser from '../../common/withUser';
import withScanInventory from '../../common/withScanInventory';
import withSingleScanSession from '../../common/withSingleScanSession';
import withOnline from '../../common/withOnline';
import {
  onGoBack,
  sortData,
  // SERVER_TIMEZONE,
  createNewSession,
  Fcm_Token,
  getSyncTeamAbb
} from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import {
  getHospitals,
  getTeamReps,
  getInventoryByAccountName,
  getInventoryByID,
  getInventoryBySessionID,
  updateInventoryByInventoryId,
  updateInventoryByLocalInventoryId,
  deleteByPrimaryKey
} from '../../utils/db';
import {
  saveScanInventoryData,
  submitScanData
} from '../../utils/utils';
import DeleteScanSessionModal from '../../components/Models/DeleteScanSessionModal';
import OptimizeDatePicker from '../../components/commonComponents/OptimizeDatePicker';

class ScanSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      expiringDay: 0,
      session: [],
      account: [],
      selectedAccountName: '',
      productCount: 0,
      selectedSessionName: '',
      sessionId: '',
      selectedSessionNewOrOld: '',
      selectedSession: '',
      isProduct: false,
      isExpire: true,
      isConsignment: false,
      isSubmitted: true
    };
    this.deleteScanSessionModal = null;
  }

  componentDidMount() {
    this.deleteScanSessionModal = new window.bootstrap.Modal(window.$('#DeleteScanSessionModal'));
    document.getElementById('expireDate').setAttribute('readonly', 'readonly');
  }

  _goBack = () => {
    try {
      const { goBack, setScanInventory } = this.props;
      onGoBack(goBack);
      setScanInventory({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onScanInventory = () => {
    try {
      const {
        setScanInventory, scanInventory, setSingleScanSession,
        user: {
          name, salesRepNo, selectedTeam, territories, office,
          selectedTeam: { timezone }
        }
      } = this.props;
      const {
        productCount, isProduct, isExpire, startDate, expiringDay, isConsignment
      } = this.state;
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      setScanInventory({
        ...scanInventory,
        ProductBarcode: null,
        LotBarcode: '',
        ProductNo: '',
        ProductDescription: '',
        Qty: 0,
        totalProduct: productCount,
        Submitted: 0,
        LotNo: '',
        OfficeName: officeData.name,
        ExpireDate: '',
        ScanRep: name,
        TeamName: selectedTeam.name,
        SalesRepNo: salesRepNo,
        BarcodeType: '',
        ProductEnterType: '',
        LotEnterType: '',
        ExpDateEnterType: '',
        ProductValid: true,
        // ScanDate: moment().tz(SERVER_TIMEZONE).format('YYYY-MM-DD, HH:mm:ss A'),
        ScanDate: moment().tz(timezone).format('YYYY-MM-DD, HH:mm:ss A'),
        // ScanDate: moment().format('YYYY-MM-DD, HH:mm:ss A'),

        // SessionDate: moment().format('YYYY-MM-DD, HH:mm:ss A'),
        // SessionDate: scanInventory.SessionDate,
        // SessionDate: moment().tz(timezone).format('YYYY-MM-DD, HH:mm:ss A'),
        DeviceID: Fcm_Token,
        ID: null,
        isProduct,
        isExpire,
        expiringDay,
        startDate,
        isConsignment
      });
      setSingleScanSession({});
      this._onGoBack();
      browserHistory.push('/inventory/consignment/scan-session/scan-inventory');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEditSession = async () => {
    try {
      const { setSingleScanSession, scanInventory, setScanInventory } = this.props;
      const { isProduct, isExpire, isConsignment } = this.state;
      setScanInventory({
        ...scanInventory, isProduct, isExpire, isConsignment
      });
      setSingleScanSession(scanInventory);
      this._onGoBack();
      browserHistory.push('/inventory/consignment/scan-session/edit-session');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onViewInventory = () => {
    try {
      const { setScanInventory, scanInventory } = this.props;
      const { isProduct, isExpire, isConsignment } = this.state;
      setScanInventory({
        ...scanInventory, isProduct, isExpire, isConsignment
      });
      this._onGoBack();
      browserHistory.push('/inventory/consignment/scan-session/scan-view-inventory');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeDay = (e) => {
    try {
      const newDate = moment(new Date()).add(e.target.value, 'days');
      this.setState({
        startDate: e.target.value !== '' ? new Date(newDate) : new Date()
      });
    } catch (er) {
      Bugsnag.notify(er);
    }
  }

  _onChangeDate = (value) => {
    try {
      const selectedDate = moment(value);
      const currentDate = moment();
      this.setState({
        expiringDay: moment().format('MM/DD/yyyy') === moment(value).format('MM/DD/yyyy')
          ? 0
          : selectedDate.diff(currentDate, 'days') + 1,
        startDate: value
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetAccountName = async () => {
    try {
      const { user } = this.props;
      const hospitalRes = await getHospitals();
      const sortHospital = sortData(hospitalRes, 'CustomerName');
      const repRes = await getTeamReps();
      const sortRep = sortData(repRes, 'SalesRepName');
      const teamRes = user.selectedTeam;
      const teamNo = sortHospital[0].TeamNo;
      teamRes.AccountNameAndNumber = user.selectedTeam.name;
      teamRes.AccountName = user.selectedTeam.name;
      teamRes.AccountNo = (teamNo).toString();
      teamRes.AccountAbb = await getSyncTeamAbb();
      const teamArr = [];
      teamArr.push(teamRes);
      sortHospital.map((value) => {
        value.AccountNameAndNumber = `${value.CustomerName} (${(value.CustomerNo).toString() === 'NaN' ? '0' : (value.CustomerNo).toString()})`;
        value.AccountName = value.CustomerName;
        value.AccountNo = (value.CustomerNo).toString() === 'NaN' ? '0' : (value.CustomerNo).toString();
        value.AccountAbb = value.CustomerAbb;
      });
      sortRep.map((value) => {
        value.AccountNameAndNumber = `${value.SalesRepName} (${((value.SalesRepNo !== '' && value.SalesRepNo !== null) ? (value.SalesRepNo).toString() : '')})`;
        value.AccountName = value.SalesRepName;
        value.AccountNo = (value.SalesRepNo !== null && (value.SalesRepNo).toString());
        value.AccountAbb = value.SalesRepName.substr(0, value.SalesRepName.indexOf(','));
      });
      const merged = _(teamArr)
        .concat(sortRep, sortHospital)
        .groupBy('AccountName')
        .map(_.spread(_.merge))
        .value();
      this.setState({
        account: merged
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeSessionName = (value) => {
    try {
      const { setScanInventory, scanInventory } = this.props;
      this.setState({
        selectedSessionName: value
      });
      setScanInventory({
        ...scanInventory,
        SessionName: value,
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProduct = () => {
    try {
      const { isProduct } = this.state;
      const { setScanInventory, scanInventory } = this.props;
      this.setState({ isProduct: !isProduct });
      setScanInventory({
        ...scanInventory,
        isProduct: !isProduct
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAlertExpireDate = () => {
    try {
      const { startDate, isExpire, expiringDay } = this.state;
      const { setScanInventory, scanInventory } = this.props;
      this.setState({ isExpire: !isExpire });
      setScanInventory({
        ...scanInventory, isExpire: !isExpire, expiringDay, startDate
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCheckConsignment = () => {
    try {
      const { isConsignment } = this.state;
      const { setScanInventory, scanInventory } = this.props;
      this.setState({ isConsignment: !isConsignment });
      setScanInventory({
        ...scanInventory,
        isConsignment: !isConsignment
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeSession = async (value) => {
    try {
      const {
        setScanInventory,
        scanInventory
      } = this.props;
      const { session } = this.state;
      // const teamAbb = await getSyncTeamAbb();
      const result = session.find((x) => x.sessionNameWithId === value);
      const getInventoryBySessionIDRes
        = await getInventoryBySessionID(result.SessionID);
      this.setState({
        selectedSession: value,
        sessionId: value === 'CREATE NEW SESSION' ? scanInventory.AccountAbb + moment().format('_DDMMMYYYY_hhmmssA') : result.SessionID,
        selectedSessionNewOrOld: value === 'CREATE NEW SESSION' ? 'new' : 'old',
        productCount: value !== 'CREATE NEW SESSION' ? getInventoryBySessionIDRes.length : 0,
        SessionDate: result.SessionDate
        // SessionDate: value !== 'CREATE NEW SESSION' ? result.SessionDate
        // : moment().format('YYYY-MM-DD HH:mm:ss.SSS')
      }, () => {
        this._onFocusSessionName(value);
      });
      setScanInventory({
        ...scanInventory,
        SessionName: value === 'CREATE NEW SESSION' ? '' : result.SessionName,
        SessionID: value === 'CREATE NEW SESSION' ? scanInventory.AccountAbb + moment().format('_DDMMMYYYY_hhmmssA') : result.SessionID,
        SessionNewOrOld: value === 'CREATE NEW SESSION' ? 'new' : 'old',
        Qty: value !== 'CREATE NEW SESSION' ? getInventoryBySessionIDRes.length : 0,
        // SessionDate: value !== 'CREATE NEW SESSION' ? result.SessionDate
        // : moment().format('YYYY-MM-DD HH:mm:ss.SSS')
        // SessionDate: moment(result.SessionDate).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS')
        // SessionDate: moment(result.SessionDate).format('YYYY-MM-DD HH:mm:ss.SSS')
        SessionDate: result.SessionDate
      });
      await this._onGetInventorySession(result.SessionID);
      this.setState({ selectedSessionName: result.SessionName });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFocusSessionName = async (value) => {
    try {
      if (value === 'CREATE NEW SESSION') {
        setTimeout(() => {
          window.$('#SessionName').focus();
        }, 100);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeAccount = async (key) => {
    try {
      const {
        account, selectedAccountName
      } = this.state;
      if (account[key] !== undefined) {
        const {
          AccountName, AccountAbb, AccountNo
        } = account[key];
        const { setScanInventory, scanInventory } = this.props;
        if (selectedAccountName !== key) {
          this.setState({
            sessionId: '', productCount: 0, isProduct: false, isConsignment: false
          });
        }
        this.setState({ selectedAccountName: key }, () => {
          setTimeout(() => {
            selectedAccountName !== '' && $('#selectSession').select2('open');
          }, 100);
        });
        setScanInventory({
          ...scanInventory, AccountName, AccountAbb, AccountNo
        });
        await this._getInventoryByAccountName(AccountName);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getInventoryByAccountName = async (accountName) => {
    try {
      const {
        user: { selectedTeam: { timezone } }
      } = this.props;

      if (accountName !== undefined) {
        if (accountName.length > 0) {
          const getInventoryByAccountNameRes
            = await getInventoryByAccountName(accountName);

          let sessionWiseInventoryData = [];
          // const sessionDate = getInventoryByAccountNameRes.length > 0
          //   ? getInventoryByAccountNameRes[0].SessionDate
          //   : moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          getInventoryByAccountNameRes.map((value) => {
            value.sessionNameWithId = value.SessionName === '' ? value.SessionID : `${value.SessionName}(${value.SessionID})`;
            sessionWiseInventoryData.push({
              sessionNameWithId: value.sessionNameWithId,
              SessionName: value.SessionName,
              SessionID: value.SessionID,
              // SessionDate: sessionDate
              SessionDate: value.SessionDate
            });
          });
          sessionWiseInventoryData = [...new Map(
            sessionWiseInventoryData.map(
              (item) => [item.SessionID, item]
            )
          ).values()];
          sessionWiseInventoryData = _.filter(sessionWiseInventoryData,
            (v) => _.keys(v).length !== 0);

          const newSessionDate = await moment(new Date()).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');

          sessionWiseInventoryData.unshift({
            SessionID: '',
            SessionName: '',
            sessionNameWithId: 'CREATE NEW SESSION',
            SessionDate: newSessionDate
          });

          const createNewSessionRes = await createNewSession(sessionWiseInventoryData, 'sessionNameWithId');

          this.setState({
            session: createNewSessionRes
          });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitSession = async () => {
    try {
      const {
        scanInventory, online, notify, setLoader
      } = this.props;
      const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);
      if (online) {
        const scanInventoryID = [];
        let responseJson = {};
        let submitResponseJson = {};
        setLoader(true);
        // eslint-disable-next-line no-async-promise-executor
        const hospitalPromiseAll = inventoryRes.map(async (data) => new Promise(async (resolve) => {
          if (data.ID === null) {
            responseJson = await saveScanInventoryData(data);
            const { message, status, ID } = responseJson;
            if (status) {
              data.ID = ID;
              await updateInventoryByLocalInventoryId(data.inventoryId, data);
              await this._onGetInventorySession(data.SessionID);
              scanInventoryID.push(ID);
            } else {
              notify({ type: 'error', message, time: 3 });
            }
          } else {
            scanInventoryID.push(data.ID);
          }
          resolve(true);
        }));
        setLoader(false);
        await Promise.all(hospitalPromiseAll);
        setLoader(true);
        if (scanInventoryID !== undefined && scanInventoryID.length > 0) {
          submitResponseJson = await submitScanData({ ID: scanInventoryID });
          if (submitResponseJson.hasOwnProperty('failed_IDs')) {
            const { failed_IDs } = submitResponseJson;
            scanInventoryID.map(async (id) => {
              const getInventoryResById = await getInventoryByID(id);
              if (failed_IDs.includes(id) === true) {
                getInventoryResById.Submitted = 0;
                await updateInventoryByInventoryId(id, getInventoryResById);
                await this._onGetInventorySession(getInventoryResById.SessionID);
              } else {
                getInventoryResById.Submitted = 1;
                await updateInventoryByInventoryId(id, getInventoryResById);
                await this._onGetInventorySession(getInventoryResById.SessionID);
              }
            });
          } else {
            scanInventoryID.map(async (id) => {
              const getInventoryResById = await getInventoryByID(id);
              getInventoryResById.Submitted = 1;
              await updateInventoryByInventoryId(id, getInventoryResById);
              await this._onGetInventorySession(getInventoryResById.SessionID);
            });
          }
        }
        setLoader(false);
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetInventorySession = async (data) => {
    const inventoryRes = await getInventoryBySessionID(data);
    const isFound = inventoryRes.find((o) => o.Submitted === 0);
    if (inventoryRes.length > 0) {
      if (isFound !== undefined) {
        this.setState({
          isSubmitted: false
        });
      } else {
        this.setState({
          isSubmitted: true
        });
      }
    } else {
      this.setState({
        isSubmitted: true
      });
    }
  }

  _onOpenScanSessionDeletePopup = (data) => {
    try {
      this.setState({ sessionId: data });
      this.deleteScanSessionModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDeleteSelectedSession = async (sessionId) => {
    try {
      const { setLoader, scanInventory } = this.props;
      const deleteSessionRes = await getInventoryBySessionID(sessionId);
      deleteSessionRes.map(async (item) => {
        if (item.inventoryId !== undefined) {
          setLoader(true);
          await deleteByPrimaryKey(item.inventoryId);
          await this._getInventoryByAccountName(scanInventory.AccountName);
          this.setState({
            selectedSession: '', selectedSessionName: '', sessionId: '', productCount: 0
          });
          setLoader(false);
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._onGetAccountName();
      const { scanInventory } = this.props;
      await this._getInventoryByAccountName(scanInventory.AccountName);
      const { account } = this.state;

      if (Object.keys(scanInventory).length > 0) {
        const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);
        await this._onGetInventorySession(scanInventory.SessionID);
        this.setState({
          sessionId: scanInventory.SessionID,
          selectedAccountName: account.findIndex(
            (x) => x.AccountName === scanInventory.AccountName
          ),
          selectedSession: scanInventory.SessionNewOrOld === 'new'
            ? 'CREATE NEW SESSION' : scanInventory.SessionName === '' ? scanInventory.SessionID : `${scanInventory.SessionName}(${scanInventory.SessionID})`,
          selectedSessionName: scanInventory.SessionName,
          productCount: inventoryRes.length,
          isProduct: scanInventory.isProduct,
          isExpire: scanInventory.isExpire,
          expiringDay: scanInventory.expiringDay,
          startDate: scanInventory.startDate === undefined || scanInventory.startDate === 'Invalid Date'
            ? new Date() : new Date(scanInventory.startDate),
          isConsignment: scanInventory.isConsignment
        });
      }

      // Listen for input event on numInput.
      const number = document.getElementById('number');
      number.onkeydown = function (e) {
        if (!((e.keyCode > 95 && e.keyCode < 106)
          || (e.keyCode > 47 && e.keyCode < 58)
          || e.keyCode === 8)) {
          return false;
        }
      };
      $(document).on('focus', '.select2-selection.select2-selection--single', function () {
        $(this).closest('.select2-container').siblings('select:enabled').select2('open');
      });

      // steal focus during close - only capture once and stop propogation
      $('select.select2').on('select2:closing', (e) => {
        $(e.target).data('select2').$selection.one('focus focusin', (ee) => {
          ee.stopPropagation();
        });
      });
      $('select')
        .on('select2-opening', function () {
          $(this).siblings('.select2-container').find('.select2-search, .select2-focusser').remove();
        });
      $('select').on('select2:open', () => {
        $('.select2-search__field').remove();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      startDate,
      expiringDay,
      session,
      selectedSession,
      account,
      selectedAccountName,
      productCount,
      selectedSessionName,
      sessionId,
      isProduct,
      isExpire,
      isConsignment,
      isSubmitted
    } = this.state;
    const { scanInventory } = this.props;
    return (
      <section className="list-section resizer-class">
        <Header
          title="Scan Session"
          goBack={this._goBack}
        />
        <section className="case-details-section">
          <div className="container">
            <div className="row gx-2">
              <div className="col-12">
                <div className="case-data">
                  <label htmlFor="account">Account</label>
                  <Select2
                    className="form-control select-2-black rounded w-100"
                    id="accountName"
                    onSelect={({ target: { value } }) => {
                      this._onChangeAccount(value);
                    }}
                    data={account.map((value, key) => (
                      { id: key, text: value.AccountNameAndNumber }))}
                    value={selectedAccountName}
                    options={{ placeholder: 'Select Account' }}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="case-data session-field">
                  <label htmlFor="scan">Session</label>
                  <Select2
                    className="form-control select-2-black rounded w-100"
                    id="selectSession"
                    onSelect={({ target: { value } }) => {
                      this._onChangeSession(value);
                    }}
                    data={session.map((value) => value.sessionNameWithId)}
                    value={selectedSession}
                    disabled={selectedAccountName === ''}
                    options={{ placeholder: 'Select Session' }}
                  />
                  {
                    (scanInventory !== undefined && scanInventory.SessionNewOrOld === 'new')
                    && (
                      <input
                        type="text"
                        className="form-control view-int-input"
                        id="SessionName"
                        name="SessionName"
                        onChange={({ target: { value } }) => {
                          this._onChangeSessionName(value);
                        }}
                        value={selectedSessionName}
                        placeholder="Session Name"
                        disabled={productCount > 0}
                      />
                    )
                  }
                </div>
              </div>
              <div className="col-12 col-md-12">
                <p>{`Session ID: ${selectedSession === '' ? '' : sessionId !== undefined ? sessionId : ''}`}</p>
              </div>
              <div className="col-12 col-md-12">
                <p>Products: {productCount}</p>
              </div>
              <div className="col-12 col-md-12">
                <div className="case-data pb-3">
                  <label className="cursor-pointer mt-2">
                    <input
                      type="checkbox" id="onlyProduct"
                      onClick={this._onProduct}
                      checked={isProduct}
                      readOnly
                    />
                    <span className="me-2" />
                    Product scans only (no Lot scans)
                  </label>
                </div>
              </div>
              <div className="col-5 col-md-2">
                <div className="case-data">
                  <label className="cursor-pointer mt-2">
                    <input
                      type="checkbox" id="alertExpire"
                      name="alertExpire"
                      onClick={this._onAlertExpireDate}
                      checked={isExpire}
                    />
                    <span className="me-2" />
                    Alert if expiring in
                  </label>
                </div>
              </div>
              <div className="col-7">
                <div className="case-data row g-2">
                  <div className="col-6 col-md-auto mt-0">
                    <input
                      min="0"
                      className="form-control d-inline-block text-center view-int-input expire-days-truncate"
                      style={{ width: '40px', paddingLeft: '5px', paddingRight: '5px' }}
                      type="number" id="number"
                      onChange={(e) => {
                        if (e.target.value.length === 7) return false;
                        this.setState({
                          expiringDay: e.target.value,
                        }, () => {
                          this._onChangeDay(e);
                        });
                      }}
                      value={expiringDay}
                      onBlur={() => {
                        this.setState({
                          expiringDay: expiringDay === '' ? 0 : expiringDay,
                        });
                      }}
                      onWheel={(event) => event.currentTarget.blur()}
                    />
                    <label
                      htmlFor="days" style={{ marginLeft: '3px', marginRight: '3px' }}
                    > days on
                    </label>
                  </div>
                  <div className="col-6 mt-0">
                    <div className="d-inline-block">
                      <OptimizeDatePicker
                        dateFormat="MM/dd/yyyy"
                        style={{ maxWidth: '50px' }}
                        id="expireDate"
                        className="case-data view-int-input form-control scanSession-date-field"
                        placeholderText="Start Date"
                        selected={startDate}
                        onChangeRaw={(e) => {
                          e.preventDefault();
                        }}
                        minDate={new Date()}
                        showDisabledMonthNavigation
                        onChange={(value) => {
                          this._onChangeDate(value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12">
                <div className="case-data">
                  <label className="cursor-pointer mt-2">
                    <input
                      type="checkbox" id="alertConsignment"
                      name="alertConsignment" value="consignment"
                      onClick={this._onCheckConsignment}
                      checked={isConsignment}
                    />
                    <span className="me-2" />
                    Alert if not in Consignment Inventory
                  </label>
                </div>
              </div>
            </div>
            <div className="row gy-3 gx-2 mt-4">
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-theme-alt btn-theme-outline-alt w-100"
                  onClick={this._onScanInventory}
                  disabled={(selectedSession === '')}
                >Scan Inventory
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-theme-alt btn-theme-outline-alt w-100"
                  disabled={(productCount === 0)}
                  onClick={this._onEditSession}
                >Edit Session
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-theme-alt btn-theme-outline-alt w-100"
                  disabled={(productCount === 0)}
                  onClick={this._onViewInventory}
                >View Inventory
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  disabled={(productCount === 0)}
                  className="btn btn-theme-alt btn-theme-outline-alt w-100"
                  onClick={() => this._onOpenScanSessionDeletePopup(sessionId)}
                >Delete Session
                </button>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <button
                  type="button"
                  disabled={(productCount === 0 || (isSubmitted === true))}
                  className={`${isSubmitted ? 'btn btn-theme-alt btn-theme-outline-alt' : 'btn btn-red'} w-100`}
                  onClick={this._onSubmitSession}
                >Submit Session
                </button>
              </div>
            </div>
          </div>

          <DeleteScanSessionModal
            sessionId={sessionId}
            onClickYes={this._onDeleteSelectedSession}
          />
        </section>
      </section>
    );
  }
}

export default withUser(
  withOnline(
    withScanInventory(
      withSingleScanSession(
        withGoBack(
          withNotify(
            withLoader(
              ScanSession
            )
          )
        )
      )
    )
  )
);
